module.exports = __webpack_public_path__ + "static/img/liL.ac3fe080.svg";